import { Component, OnInit } from '@angular/core';
import { AdminHazardMasterServices } from "../../../Services/Admin/HazardServices";
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CheckAuth } from '../../../Services/UtilityService';
import { hazardMaster } from '../../../Models/HazardMasterModel';
@Component({
  selector: 'app-manage-hazards-list',
  templateUrl: './manage-hazards-list.component.html',
  styleUrls: ['./manage-hazards-list.component.css']
})
export class ManageHazardsListComponent implements OnInit {
  hazardMaster: hazardMaster[] = [];
  tokenKey: string = '';
  statusCode: number = 0;
  totalPageSize: number = 0;
  pageSize: number = 0;
  pageIndex: number = 0;
  orderBy: string = 'null';
  whereCondition: string = 'null';
  deleteId: string = '0';
  isAscending: boolean;
  refreshTable: boolean = true;
  upDowInductryNameCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowDisplayOrderCSS: string = '';

  constructor(private toastr: ToastrService, private checkAuth: CheckAuth, private hazardServices: AdminHazardMasterServices, private router: Router) {
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
  }

  ngOnInit() {
    this.refreshTable = true;
    this.pageSize = 10;
    this.totalPageSize = 1;
    this.pageIndex = 1;
    this.whereCondition = 'null';
    this.orderBy = 'DisplayOrder DESC';
    this.isAscending = false;
    this.getHazards();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  getHazards() {
    this.hazardServices.GetHazardMaster(this.tokenKey, this.pageIndex.toString(), this.pageSize.toString(), this.whereCondition, this.orderBy).subscribe(
      data => {
        debugger;
        this.hazardMaster = data["hazardMaster"];
        if (this.hazardMaster.length > 0)
          this.totalPageSize = parseInt(this.hazardMaster[0].totalRecords);
      },
      error => this.statusCode = error,
    );
  }

  pageChanged($event) {
    this.pageIndex = parseInt($event.page);
    this.getHazards();
  }

  setHazardMasterId(Id: string) {
    this.deleteId = Id;
  }

  editHazardMaster(id: string) {
    debugger;
    let navigation = '/admin/hazards/edit/' + id;
    this.router.navigate([navigation]);
  }

  sort(sortBy: string) {
    debugger;

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "HazardName") {
        this.upDowInductryNameCSS = 'fa fa-arrow-up';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowInductryNameCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
        this.upDowDisplayOrderCSS = '';
      }
      // else if (sortBy === "DisplayOrder") {
      //   this.upDowInductryNameCSS = '';
      //   this.upDowIsActiveCSS = '';
      //   this.upDowDisplayOrderCSS = 'fa fa-arrow-up';
      // }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "HazardName") {
        this.upDowInductryNameCSS = 'fa fa-arrow-down';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowInductryNameCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
        this.upDowDisplayOrderCSS = '';
      }
      // else if (sortBy === "DisplayOrder") {
      //   this.upDowInductryNameCSS = '';
      //   this.upDowIsActiveCSS = '';
      //   this.upDowDisplayOrderCSS = 'fa fa-arrow-down';
      // }

    }

    this.getHazards();
  }

  deleteHazards(deleteID: any) {
    debugger;
    if (deleteID != null && deleteID != "") {
      this.hazardServices.DeleteHazardMaster(this.tokenKey, deleteID).subscribe(
        data => {
          debugger;
          this.pageSize = 10;
          this.totalPageSize = 1;
          this.pageIndex = 1;
          this.whereCondition = 'null';
          this.orderBy = 'DisplayOrder DESC';
          this.isAscending = false;
          this.getHazards();
          this.refreshGrid();
          this.showMessage('Hazard deleted successfully', 'Deleted', 'success');
        },
        error => this.statusCode = error,
      );
    }
  }

  showErrorMessage() {
    debugger;
    if (sessionStorage.getItem("HazardCRUDStatus") !== null) {
      if (sessionStorage.getItem("HazardCRUDStatus") === 'Added') {
        this.showMessage('Hazard added successfully', 'Added', 'success');
        sessionStorage.removeItem('HazardCRUDStatus');
      }
      else if (sessionStorage.getItem("HazardCRUDStatus") === 'Edited') {
        this.showMessage('Hazard updated successfully', 'Edited', 'success');
        sessionStorage.removeItem('HazardCRUDStatus');
      }
    }
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  refreshGrid(): void {
    this.refreshTable = false;
    setTimeout(() => {
      this.refreshTable = true;
      this.pageIndex = 1;
    }, 10);
  }

}
